import {
  home_navMenuVertical_children,
  bigScreen_navMenuVertical_children,
  app_navMenuVertical_children
} from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxNavMenuVertical = {
  name: "cxNavMenuVertical",
  desc: "树形菜单样式",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "树形菜单",
        children: app_navMenuVertical_children,
        group: "element",
        enable(params) {
          let homePageBusinessFlag = true
          let detailPageBusinessFlag = true
          if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
            homePageBusinessFlag = false
          }
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && homePageBusinessFlag && detailPageBusinessFlag
        },
        sort: 70
      }
    ],
    bigScreen: [
      {
        name: "树形菜单",
        children: bigScreen_navMenuVertical_children,
        type: "cxNavMenuVertical"
      }
    ],
    portal: [
      {
        name: "树形菜单",
        children: home_navMenuVertical_children,
        group: "element",
        enable(params) {
          let homePageBusinessFlag = true
          let detailPageBusinessFlag = true
          if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
            homePageBusinessFlag = false
          }
          return params.admin && homePageBusinessFlag
        },
        sort: 70
      }
    ]
  },
  toolbars: [
    {
      name: "cxNavMenuVertical",
      label: "树形菜单",
      comp: {
        navMenuVerticalComponentData: () => import("./toolbars/navMenuVertical-options-data.vue"),
        navMenuVerticalComponentSetting: () => import("./toolbars/navMenuVertical-options-setting.vue"),
        navMenuVerticalComponentConfig: () => import("./toolbars/navMenuVertical-options-config.vue"),
        navMenuVerticalComponentStyle: () => import("./toolbars/navMenuVertical-options-style.vue")
      }
    }
  ]
}

export default cxNavMenuVertical
